import { API_BASE_URL, API_SECRET_KEY } from '../constants/config';

function authHeaders(extra = {}) {
  const h = { 'Content-Type': 'application/json', ...extra };
  if (API_SECRET_KEY) h['Authorization'] = `Bearer ${API_SECRET_KEY}`;
  return h;
}

export const verifyToken = async (token) => {
  const response = await fetch(`${API_BASE_URL}/verify-token`, {
    method: 'POST',
    headers: authHeaders(),
    body: JSON.stringify({ token })
  });
  return await response.json();
};

export const checkRedeemCode = async (code) => {
  const response = await fetch(`${API_BASE_URL}/check-redeem-code`, {
    method: 'POST',
    headers: authHeaders(),
    body: JSON.stringify({ code })
  });
  return await response.json();
};

export const submitTask = async (taskData) => {
  const response = await fetch(`${API_BASE_URL}/submit-task`, {
    method: 'POST',
    headers: authHeaders(),
    body: JSON.stringify(taskData)
  });
  return await response.json();
};

export const getTaskStatus = async (taskId) => {
  const response = await fetch(`${API_BASE_URL}/task-status/${taskId}`, {
    headers: authHeaders(),
  });
  return await response.json();
};

export const retrySelfCard = async (data) => {
  const response = await fetch(`${API_BASE_URL}/retry-self-card`, {
    method: 'POST',
    headers: authHeaders(),
    body: JSON.stringify(data),
  });
  return await response.json();
};